import {ChangeDetectionStrategy, Component} from '@angular/core';

require('./bringoz-circular-progress.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-circular-progress',
  templateUrl: './bringoz-circular-progress.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozCircularProgressComponent {
}
